<!-- <mat-horizontal-stepper [linear]="true" #stepper> -->
    <mat-vertical-stepper [linear]="true" #vstepper>
    <!-- Step 1: Project Identification -->
    <mat-step [stepControl]="projectFormGroup">
        <form [formGroup]="projectFormGroup">
            <ng-template matStepLabel>Project Identification</ng-template>

            <div class="form-row">
                <!-- Project Name -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Project Name/ID</mat-label>
                    <input matInput formControlName="projectName" />
                    <mat-error *ngIf="projectFormGroup.get('projectName')?.hasError('required')">
                        Project Name is required
                    </mat-error>
                </mat-form-field>

                <!-- Project Type -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Project Type</mat-label>
                    <mat-select formControlName="projectType">
                        <mat-option value="New construction">New construction</mat-option>
                        <mat-option value="Expansion">Expansion</mat-option>
                        <mat-option value="Rehabilitation">Rehabilitation</mat-option>
                    </mat-select>
                    <mat-error *ngIf="projectFormGroup.get('projectType')?.hasError('required')">
                        Project Type is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Location -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Location/Geography</mat-label>
                    <input matInput formControlName="location" />
                    <mat-error *ngIf="projectFormGroup.get('location')?.hasError('required')">
                        Location is required
                    </mat-error>
                </mat-form-field>

                <!-- Road Classification -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Road Classification</mat-label>
                    <mat-select formControlName="roadClassification">
                        <mat-option value="National Highway">National Highway</mat-option>
                        <mat-option value="State Highway">State Highway</mat-option>
                        <mat-option value="District Road">District Road</mat-option>
                    </mat-select>
                    <mat-error *ngIf="projectFormGroup.get('roadClassification')?.hasError('required')">
                        Road Classification is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Project Stage -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Project Stage</mat-label>
                    <mat-select formControlName="projectStage">
                        <mat-option value="Planning">Planning</mat-option>
                        <mat-option value="Design">Design</mat-option>
                        <mat-option value="Tendering">Tendering</mat-option>
                        <mat-option value="Construction">Construction</mat-option>
                        <mat-option value="Handover">Handover</mat-option>
                    </mat-select>
                    <mat-error *ngIf="projectFormGroup.get('projectStage')?.hasError('required')">
                        Project Stage is required
                    </mat-error>
                </mat-form-field>

                <!-- Start Date -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                    <mat-error *ngIf="projectFormGroup.get('startDate')?.hasError('required')">
                        Start Date is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- End Date -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Estimated Completion Date</mat-label>
                    <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                    <mat-error *ngIf="projectFormGroup.get('endDate')?.hasError('required')">
                        Completion Date is required
                    </mat-error>
                </mat-form-field>

                <!-- Authority -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Project Owner/Authority</mat-label>
                    <input matInput formControlName="authority" />
                    <mat-error *ngIf="projectFormGroup.get('authority')?.hasError('required')">
                        Authority is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div>
                <button mat-button matStepperNext [disabled]="!projectFormGroup.valid">Next</button>
            </div>
        </form>
    </mat-step>

    <!-- Step 2: Road Specifications -->
    <mat-step [stepControl]="roadSpecsFormGroup">
        <form [formGroup]="roadSpecsFormGroup">
            <ng-template matStepLabel>Road Specifications</ng-template>

            <div class="form-row">
                <!-- Road Length -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Road Length (km)</mat-label>
                    <input matInput type="number" formControlName="length" />
                    <mat-error *ngIf="roadSpecsFormGroup.get('length')?.hasError('required')">Road Length is
                        required</mat-error>
                    <mat-error *ngIf="roadSpecsFormGroup.get('length')?.hasError('min')">Minimum 0.1 km</mat-error>
                </mat-form-field>

                <!-- Number of Lanes -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Number of Lanes</mat-label>
                    <mat-select formControlName="lanes">
                        <mat-option *ngFor="let n of [1,2,3,4,5,6]" [value]="n">{{n}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="roadSpecsFormGroup.get('lanes')?.hasError('required')">Number of lanes is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Lane Width -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Lane Width (m)</mat-label>
                    <input matInput type="number" formControlName="laneWidth" />
                    <mat-error *ngIf="roadSpecsFormGroup.get('laneWidth')?.hasError('required')">Lane width is
                        required</mat-error>
                </mat-form-field>

                <!-- Surface Type -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Road Surface Type</mat-label>
                    <mat-select formControlName="surfaceType">
                        <mat-option value="Asphalt/Bituminous">Asphalt/Bituminous</mat-option>
                        <mat-option value="Concrete/Cement">Concrete/Cement</mat-option>
                        <mat-option value="Composite">Composite</mat-option>
                    </mat-select>
                    <mat-error *ngIf="roadSpecsFormGroup.get('surfaceType')?.hasError('required')">Surface type is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Design Speed -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Design Speed (km/hr)</mat-label>
                    <input matInput type="number" formControlName="designSpeed" />
                    <mat-error *ngIf="roadSpecsFormGroup.get('designSpeed')?.hasError('required')">Design speed is
                        required</mat-error>
                </mat-form-field>

                <!-- Traffic Volume -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Traffic Volume (PCU)</mat-label>
                    <input matInput type="number" formControlName="trafficVolume" />
                    <mat-error *ngIf="roadSpecsFormGroup.get('trafficVolume')?.hasError('required')">Traffic volume is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Design Life -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Design Life (years)</mat-label>
                    <input matInput type="number" formControlName="designLife" />
                    <mat-error *ngIf="roadSpecsFormGroup.get('designLife')?.hasError('required')">Design life is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext [disabled]="!roadSpecsFormGroup.valid">Next</button>
            </div>
        </form>


    </mat-step>

    <!-- Step 3: Site Conditions -->
    <mat-step [stepControl]="siteFormGroup">
        <form [formGroup]="siteFormGroup">
            <ng-template matStepLabel>Site Conditions</ng-template>

            <div class="form-row">
                <!-- Terrain Type -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Terrain Type</mat-label>
                    <mat-select formControlName="terrainType">
                        <mat-option value="Plain">Plain</mat-option>
                        <mat-option value="Rolling">Rolling</mat-option>
                        <mat-option value="Mountainous">Mountainous</mat-option>
                        <mat-option value="Steep">Steep</mat-option>
                    </mat-select>
                    <mat-error *ngIf="siteFormGroup.get('terrainType')?.hasError('required')">Terrain Type is
                        required</mat-error>
                </mat-form-field>

                <!-- Soil Type -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Soil Type</mat-label>
                    <mat-select formControlName="soilType">
                        <mat-option value="Clay">Clay</mat-option>
                        <mat-option value="Sandy">Sandy</mat-option>
                        <mat-option value="Silt">Silt</mat-option>
                        <mat-option value="Gravel">Gravel</mat-option>
                    </mat-select>
                    <mat-error *ngIf="siteFormGroup.get('soilType')?.hasError('required')">Soil Type is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- CBR -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>CBR (%)</mat-label>
                    <input matInput type="number" formControlName="cbr" />
                    <mat-error *ngIf="siteFormGroup.get('cbr')?.hasError('required')">CBR is required</mat-error>
                </mat-form-field>

                <!-- Plasticity Index -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Plasticity Index</mat-label>
                    <input matInput type="number" formControlName="plasticityIndex" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Moisture Content -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Moisture Content (%)</mat-label>
                    <input matInput type="number" formControlName="moistureContent" />
                </mat-form-field>

                <!-- Rainfall Pattern -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Rainfall Pattern</mat-label>
                    <mat-select formControlName="rainfallPattern">
                        <mat-option value="Heavy">Heavy</mat-option>
                        <mat-option value="Moderate">Moderate</mat-option>
                        <mat-option value="Low">Low</mat-option>
                    </mat-select>
                    <mat-error *ngIf="siteFormGroup.get('rainfallPattern')?.hasError('required')">Rainfall Pattern is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Flood History -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Flood History</mat-label>
                    <mat-select formControlName="floodHistory">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                    </mat-select>
                    <mat-error *ngIf="siteFormGroup.get('floodHistory')?.hasError('required')">Flood History is
                        required</mat-error>
                </mat-form-field>

                <!-- Water Table -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Water Table Depth (m)</mat-label>
                    <input matInput type="number" formControlName="waterTable" />
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Temperature Range -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Temperature Range (°C)</mat-label>
                    <input matInput formControlName="temperatureRange" />
                    <mat-error *ngIf="siteFormGroup.get('temperatureRange')?.hasError('required')">Temperature range is
                        required</mat-error>
                </mat-form-field>

                <!-- Frost Susceptibility -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Frost Susceptibility</mat-label>
                    <mat-select formControlName="frostSusceptibility">
                        <mat-option value="High">High</mat-option>
                        <mat-option value="Medium">Medium</mat-option>
                        <mat-option value="Low">Low</mat-option>
                    </mat-select>
                    <mat-error *ngIf="siteFormGroup.get('frostSusceptibility')?.hasError('required')">Frost
                        susceptibility is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <!-- Special Zone -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Special Zone (Seismic/Environmental)</mat-label>
                    <input matInput formControlName="specialZone" />
                </mat-form-field>
            </div>

            <div>
                <button mat-button matStepperPrevious>Back</button>

                <button mat-button matStepperNext [disabled]="!siteFormGroup.valid">Next</button>
            </div>
        </form>

    </mat-step>

    <!-- Step 4: designFormGroup Conditions -->
    <mat-step [stepControl]="designFormGroup">
        <form [formGroup]="designFormGroup">
            <ng-template matStepLabel>Pavement Design</ng-template>

            <!-- Pavement Design Section -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Pavement Type</mat-label>
                    <mat-select formControlName="pavementType">
                        <mat-option value="Flexible">Flexible</mat-option>
                        <mat-option value="Rigid">Rigid</mat-option>
                        <mat-option value="Composite">Composite</mat-option>
                    </mat-select>
                    <mat-error *ngIf="designFormGroup.get('pavementType')?.hasError('required')">Pavement Type is
                        required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Layer Thicknesses (mm)</mat-label>
                    <input matInput type="number" formControlName="layerThicknesses" />
                    <mat-error *ngIf="designFormGroup.get('layerThicknesses')?.hasError('required')">Layer Thicknesses
                        are
                        required</mat-error>
                </mat-form-field>
            </div>
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Material Specifications</mat-label>
                    <textarea matInput rows="3" formControlName="materialSpecifications"></textarea>
                    <mat-error *ngIf="designFormGroup.get('materialSpecifications')?.hasError('required')">Material
                        specifications
                        are required</mat-error>
                </mat-form-field>
            </div>


            <!-- Geometric Design Section -->
            <h3>Geometric Design</h3>
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Horizontal Alignment</mat-label>
                    <input matInput formControlName="horizontalAlignment" />
                    <mat-error
                        *ngIf="designFormGroup.get('horizontalAlignment')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Vertical Alignment</mat-label>
                    <input matInput formControlName="verticalAlignment" />
                    <mat-error
                        *ngIf="designFormGroup.get('verticalAlignment')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Super-elevation (%)</mat-label>
                    <input matInput type="number" formControlName="superelevation" />
                    <mat-error *ngIf="designFormGroup.get('superelevation')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Sight Distance (m)</mat-label>
                    <input matInput type="number" formControlName="sightDistance" />
                    <mat-error *ngIf="designFormGroup.get('sightDistance')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Drainage Design Section -->
            <h3>Drainage Design</h3>
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Side Drains</mat-label>
                    <input matInput formControlName="sideDrains" />
                    <mat-error *ngIf="designFormGroup.get('sideDrains')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Cross Drainage Structures</mat-label>
                    <input matInput formControlName="crossDrainageStructures" />
                    <mat-error
                        *ngIf="designFormGroup.get('crossDrainageStructures')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Culverts and Bridges</mat-label>
                    <input matInput formControlName="culvertsAndBridges" />
                    <mat-error
                        *ngIf="designFormGroup.get('culvertsAndBridges')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>


            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>

                <button mat-button matStepperNext [disabled]="!designFormGroup.valid">Next</button>
            </div>
        </form>

    </mat-step>

    <!-- Step 5: legalFormGroup Conditions -->

    <mat-step [stepControl]="legalFormGroup">
        <form [formGroup]="legalFormGroup">
            <ng-template matStepLabel>Land Acquisition Status</ng-template>

            <!-- Land Acquisition Section -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Land Required (hectares)</mat-label>
                    <input matInput type="number" formControlName="landRequired" />
                    <mat-error *ngIf="legalFormGroup.get('landRequired')?.hasError('required')">Required</mat-error>
                    <mat-error *ngIf="legalFormGroup.get('landRequired')?.hasError('min')">Must be > 0</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Land Acquired (hectares)</mat-label>
                    <input matInput type="number" formControlName="landAcquired" />
                    <mat-error *ngIf="legalFormGroup.get('landAcquired')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Pending Acquisitions</mat-label>
                    <input matInput formControlName="pendingAcquisitions" />
                    <mat-error
                        *ngIf="legalFormGroup.get('pendingAcquisitions')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Compensation Status</mat-label>
                    <input matInput formControlName="compensationStatus" />
                    <mat-error
                        *ngIf="legalFormGroup.get('compensationStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Environmental Clearances -->
            <h3>Environmental Clearances</h3>
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>EIA Status</mat-label>
                    <mat-select formControlName="eiaStatus">
                        <mat-option value="Not Required">Not Required</mat-option>
                        <mat-option value="Pending">Pending</mat-option>
                        <mat-option value="Approved">Approved</mat-option>
                    </mat-select>
                    <mat-error *ngIf="legalFormGroup.get('eiaStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Forest Clearance Status</mat-label>
                    <mat-select formControlName="forestClearanceStatus">
                        <mat-option value="Not Required">Not Required</mat-option>
                        <mat-option value="Pending">Pending</mat-option>
                        <mat-option value="Approved">Approved</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="legalFormGroup.get('forestClearanceStatus')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Wildlife Clearance (if applicable)</mat-label>
                <input matInput formControlName="wildlifeClearance" />
            </mat-form-field>

            <!-- Utility Shifting -->
            <h3>Utility Shifting Status</h3>
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Electrical</mat-label>
                    <input matInput formControlName="electricalShift" />
                    <mat-error *ngIf="legalFormGroup.get('electricalShift')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Water Supply</mat-label>
                    <input matInput formControlName="waterSupplyShift" />
                    <mat-error *ngIf="legalFormGroup.get('waterSupplyShift')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Telecommunications</mat-label>
                    <input matInput formControlName="telecomShift" />
                    <mat-error *ngIf="legalFormGroup.get('telecomShift')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Gas Lines</mat-label>
                    <input matInput formControlName="gasLineShift" />
                    <mat-error *ngIf="legalFormGroup.get('gasLineShift')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <!-- Other Permissions -->
            <h3>Other Permissions</h3>
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>ROW Clearance</mat-label>
                    <input matInput formControlName="rowClearance" />
                    <mat-error *ngIf="legalFormGroup.get('rowClearance')?.hasError('required')">Required</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Local Authority Permissions</mat-label>
                    <input matInput formControlName="localAuthorityPermission" />
                    <mat-error
                        *ngIf="legalFormGroup.get('localAuthorityPermission')?.hasError('required')">Required</mat-error>
                </mat-form-field>
            </div>

            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext [disabled]="!legalFormGroup.valid">Next</button>
            </div>
        </form>

    </mat-step>


    <!-- Step 6: stakeholdersForm Conditions -->

    <mat-step [stepControl]="stakeholdersForm ">
        <form [formGroup]="stakeholdersForm">
            <ng-template matStepLabel>Stakeholders</ng-template>

            <div class="form-row">
                <!-- Project Owner/Client -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Project Owner/Client</mat-label>
                    <input matInput formControlName="projectOwner" />
                    <mat-error *ngIf="stakeholdersForm.get('projectOwner')?.hasError('required')">
                        Project Owner is required
                    </mat-error>
                </mat-form-field>

                <!-- Regulatory Bodies -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Regulatory Bodies</mat-label>
                    <input matInput formControlName="regulatoryBodies" />
                    <mat-error *ngIf="stakeholdersForm.get('regulatoryBodies')?.hasError('required')">
                        Regulatory Bodies are required
                    </mat-error>
                </mat-form-field>

                <!-- Funding Agencies -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Funding Agencies</mat-label>
                    <input matInput formControlName="fundingAgencies" />
                    <mat-error *ngIf="stakeholdersForm.get('fundingAgencies')?.hasError('required')">
                        Funding Agencies are required
                    </mat-error>
                </mat-form-field>

                <!-- Local Communities -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Local Communities</mat-label>
                    <input matInput formControlName="localCommunities" />
                    <mat-error *ngIf="stakeholdersForm.get('localCommunities')?.hasError('required')">
                        Local Communities are required
                    </mat-error>
                </mat-form-field>

                <!-- Affected Property Owners -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Affected Property Owners</mat-label>
                    <input matInput formControlName="affectedOwners" />
                    <mat-error *ngIf="stakeholdersForm.get('affectedOwners')?.hasError('required')">
                        Affected Property Owners are required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!stakeholdersForm.valid">Next</button>
            </div>

        </form>

    </mat-step>


    <!-- Step 7: projectTeamsForm Conditions -->

    <mat-step [stepControl]="projectTeamsForm ">
        <form [formGroup]="projectTeamsForm">
            <ng-template matStepLabel>Project Teams</ng-template>

            <!-- Planning Team -->
            <h3>Planning Team</h3>
            <div formGroupName="planningTeam" class="form-grid">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Team Structure</mat-label>
                        <input matInput formControlName="teamStructure" />
                        <mat-error *ngIf="projectTeamsForm.get('planningTeam.teamStructure')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Roles and Responsibilities</mat-label>
                        <input matInput formControlName="roles" />
                        <mat-error *ngIf="projectTeamsForm.get('planningTeam.roles')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contact" />
                        <mat-error *ngIf="projectTeamsForm.get('planningTeam.contact')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error *ngIf="projectTeamsForm.get('planningTeam.contact')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Design Team -->
            <h3>Design Team</h3>
            <div formGroupName="designTeam" class="form-grid">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Design Consultants</mat-label>
                        <input matInput formControlName="designConsultants" />
                        <mat-error *ngIf="projectTeamsForm.get('designTeam.designConsultants')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Specialized Consultants</mat-label>
                        <input matInput formControlName="specializedConsultants" />
                        <mat-error
                            *ngIf="projectTeamsForm.get('designTeam.specializedConsultants')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contact" />
                        <mat-error *ngIf="projectTeamsForm.get('designTeam.contact')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error *ngIf="projectTeamsForm.get('designTeam.contact')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Field Team -->
            <h3>Field Team</h3>
            <div formGroupName="fieldTeam" class="form-grid">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Team Structure</mat-label>
                        <input matInput formControlName="teamStructure" />
                        <mat-error *ngIf="projectTeamsForm.get('fieldTeam.teamStructure')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Field Engineers</mat-label>
                        <input matInput formControlName="fieldEngineers" />
                        <mat-error *ngIf="projectTeamsForm.get('fieldTeam.fieldEngineers')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Supervisors</mat-label>
                        <input matInput formControlName="supervisors" />
                        <mat-error *ngIf="projectTeamsForm.get('fieldTeam.supervisors')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contact" />
                        <mat-error *ngIf="projectTeamsForm.get('fieldTeam.contact')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error *ngIf="projectTeamsForm.get('fieldTeam.contact')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Testing Team -->
            <h3>Acceptance Testing Team</h3>
            <div formGroupName="testingTeam" class="form-grid">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Quality Control Engineers</mat-label>
                        <input matInput formControlName="qcEngineers" />
                        <mat-error *ngIf="projectTeamsForm.get('testingTeam.qcEngineers')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Testing Laboratories</mat-label>
                        <input matInput formControlName="labs" />
                        <mat-error *ngIf="projectTeamsForm.get('testingTeam.labs')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contact" />
                        <mat-error *ngIf="projectTeamsForm.get('testingTeam.contact')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error *ngIf="projectTeamsForm.get('testingTeam.contact')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!projectTeamsForm.valid">Next</button>

            </div>


        </form>


    </mat-step>


    <!-- Step 8: contractorsVendorsForm Conditions -->
    <mat-step [stepControl]="contractorsVendorsForm ">
        <form [formGroup]="contractorsVendorsForm">
            <ng-template matStepLabel>Contractors Vendors</ng-template>

            <!-- Main Contractor -->
            <h3>Main Contractor</h3>
            <div formGroupName="mainContractor" class="form-grid">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Company Name</mat-label>
                        <input matInput formControlName="companyName" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('mainContractor.companyName')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Registration/License Number</mat-label>
                        <input matInput formControlName="registrationNumber" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('mainContractor.registrationNumber')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contactInfo" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('mainContractor.contactInfo')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error *ngIf="contractorsVendorsForm.get('mainContractor.contactInfo')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Performance History</mat-label>
                        <textarea matInput formControlName="performanceHistory"></textarea>
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('mainContractor.performanceHistory')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <!-- Subcontractors -->
            <h3>Subcontractors</h3>
            <div formGroupName="subcontractors" class="form-grid">
                <div class="form-row">

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Scope of Work</mat-label>
                        <input matInput formControlName="scopeOfWork" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('subcontractors.scopeOfWork')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Company Details</mat-label>
                        <textarea matInput formControlName="companyDetails"></textarea>
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('subcontractors.companyDetails')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contactInfo" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('subcontractors.contactInfo')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error *ngIf="contractorsVendorsForm.get('subcontractors.contactInfo')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Material Suppliers -->
            <h3>Material Suppliers</h3>
            <div formGroupName="materialSuppliers" class="form-grid">
                <div class="form-row">

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Material Type</mat-label>
                        <input matInput formControlName="materialType" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('materialSuppliers.materialType')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Supplier Name</mat-label>
                        <input matInput formControlName="supplierName" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('materialSuppliers.supplierName')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Quality Certifications</mat-label>
                        <textarea matInput formControlName="qualityCerts"></textarea>
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('materialSuppliers.qualityCerts')?.hasError('required')">
                            Required
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contact Email</mat-label>
                        <input matInput formControlName="contactInfo" />
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('materialSuppliers.contactInfo')?.hasError('required')">
                            Required
                        </mat-error>
                        <mat-error
                            *ngIf="contractorsVendorsForm.get('materialSuppliers.contactInfo')?.hasError('email')">
                            Invalid email
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!contractorsVendorsForm.valid">
                    Next
                </button>
            </div>

        </form>

    </mat-step>

    <!-- Step 9: equipmentToolsForm Conditions -->
    <mat-step [stepControl]="equipmentToolsForm ">
        <form [formGroup]="equipmentToolsForm" class="form-grid">
            <ng-template matStepLabel>Equipment Tools</ng-template>

            <!-- Heavy Equipment -->
            <h3>Heavy Equipment</h3>
            <div formGroupName="heavyEquipment">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Type</mat-label>
                        <input matInput formControlName="type" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('heavyEquipment.type')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Make/Model</mat-label>
                        <input matInput formControlName="makeModel" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('heavyEquipment.makeModel')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Capacity</mat-label>
                        <input matInput formControlName="capacity" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('heavyEquipment.capacity')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Ownership</mat-label>
                        <mat-select formControlName="ownership">
                            <mat-option value="Owned">Owned</mat-option>
                            <mat-option value="Rented">Rented</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="equipmentToolsForm.get('heavyEquipment.ownership')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Maintenance Schedule</mat-label>
                        <textarea matInput formControlName="maintenanceSchedule"></textarea>
                        <mat-error
                            *ngIf="equipmentToolsForm.get('heavyEquipment.maintenanceSchedule')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Testing Equipment -->
            <h3>Testing Equipment</h3>
            <div formGroupName="testingEquipment">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Type</mat-label>
                        <input matInput formControlName="type" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('testingEquipment.type')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Calibration Status</mat-label>
                        <input matInput formControlName="calibrationStatus" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('testingEquipment.calibrationStatus')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Laboratory Certification</mat-label>
                        <textarea matInput formControlName="labCertification"></textarea>
                        <mat-error
                            *ngIf="equipmentToolsForm.get('testingEquipment.labCertification')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Tools Inventory -->
            <h3>Tools Inventory</h3>
            <div formGroupName="toolsInventory">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Type and Quantity</mat-label>
                        <input matInput formControlName="typeQuantity" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('toolsInventory.typeQuantity')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Condition</mat-label>
                        <input matInput formControlName="condition" />
                        <mat-error
                            *ngIf="equipmentToolsForm.get('toolsInventory.condition')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Replacement Schedule</mat-label>
                        <textarea matInput formControlName="replacementSchedule"></textarea>
                        <mat-error
                            *ngIf="equipmentToolsForm.get('toolsInventory.replacementSchedule')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="form-actions">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!equipmentToolsForm.valid">Next</button>

            </div>


        </form>

    </mat-step>

    <!-- Step 10: projectControlsForm Conditions -->
    <mat-step [stepControl]="projectControlsForm ">
        <form [formGroup]="projectControlsForm" class="form-grid">
            <ng-template matStepLabel>Project Controls</ng-template>
            <!-- Budget -->
            <h3>Budget</h3>
            <div formGroupName="budget">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Total Project Cost</mat-label>
                        <input matInput type="number" formControlName="totalCost" />
                        <mat-error
                            *ngIf="projectControlsForm.get('budget.totalCost')?.hasError('required')">Required</mat-error>
                        <mat-error *ngIf="projectControlsForm.get('budget.totalCost')?.hasError('min')">Must be
                            non-negative</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Cost Breakdown Structure</mat-label>
                        <textarea matInput formControlName="costBreakdown"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('budget.costBreakdown')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Funding Sources</mat-label>
                        <textarea matInput formControlName="fundingSources"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('budget.fundingSources')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Payment Schedule</mat-label>
                        <textarea matInput formControlName="paymentSchedule"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('budget.paymentSchedule')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>


            <!-- Schedule -->
            <h3>Schedule</h3>
            <div formGroupName="schedule">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Work Breakdown Structure</mat-label>
                        <textarea matInput formControlName="workBreakdownStructure"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('schedule.workBreakdownStructure')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Milestone Dates</mat-label>
                        <textarea matInput formControlName="milestoneDates"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('schedule.milestoneDates')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Critical Path Activities</mat-label>
                        <textarea matInput formControlName="criticalPath"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('schedule.criticalPath')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Quality Control -->
            <h3>Quality Control</h3>
            <div formGroupName="qualityControl">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Testing Frequencies</mat-label>
                        <textarea matInput formControlName="testingFrequencies"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('qualityControl.testingFrequencies')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Acceptance Criteria</mat-label>
                        <textarea matInput formControlName="acceptanceCriteria"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('qualityControl.acceptanceCriteria')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Quality Assurance Plan</mat-label>
                        <textarea matInput formControlName="qualityAssurancePlan"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('qualityControl.qualityAssurancePlan')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Risk Management -->
            <h3>Risk Management</h3>
            <div formGroupName="riskManagement">
                <div class="form-row">
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Risk Register</mat-label>
                        <textarea matInput formControlName="riskRegister"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('riskManagement.riskRegister')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Mitigation Strategies</mat-label>
                        <textarea matInput formControlName="mitigationStrategies"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('riskManagement.mitigationStrategies')?.hasError('required')">Required</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Contingency Plans</mat-label>
                        <textarea matInput formControlName="contingencyPlans"></textarea>
                        <mat-error
                            *ngIf="projectControlsForm.get('riskManagement.contingencyPlans')?.hasError('required')">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="form-actions"><button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="!projectControlsForm.valid">Next</button>

            </div>
        </form>

    </mat-step>
    <!-- Step 11: multiTenancyForm Conditions -->
    <mat-step [stepControl]="multiTenancyForm ">
        <form [formGroup]="multiTenancyForm" class="form-grid">
            <ng-template matStepLabel>Multi-tenancy Parameters</ng-template>

            <!-- Tenant Identification -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Tenant Identification</mat-label>
                    <input matInput placeholder="Tenant ID or Name" formControlName="tenantId" />
                    <mat-error *ngIf="multiTenancyForm.get('tenantId')?.hasError('required')">
                        Tenant Identification is required
                    </mat-error>
                </mat-form-field>

                <!-- Access Control Levels -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Access Control Levels</mat-label>
                    <mat-select formControlName="accessControlLevel">
                        <mat-option value="read-only">Read Only</mat-option>
                        <mat-option value="editor">Editor</mat-option>
                        <mat-option value="admin">Admin</mat-option>
                    </mat-select>
                    <mat-error *ngIf="multiTenancyForm.get('accessControlLevel')?.hasError('required')">
                        Access Control Level is required
                    </mat-error>
                </mat-form-field>

                <!-- Data Segregation Rules -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Data Segregation Rules</mat-label>
                    <textarea matInput placeholder="Describe data isolation logic"
                        formControlName="dataSegregationRules"></textarea>
                    <mat-error *ngIf="multiTenancyForm.get('dataSegregationRules')?.hasError('required')">
                        Data Segregation Rules are required
                    </mat-error>
                </mat-form-field>

                <!-- Tenant-specific Configurations -->
                <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Tenant-specific Configurations</mat-label>
                    <textarea matInput placeholder="Provide configuration details"
                        formControlName="tenantConfigurations"></textarea>
                    <mat-error *ngIf="multiTenancyForm.get('tenantConfigurations')?.hasError('required')">
                        Configurations are required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="form-actions"><button mat-button matStepperPrevious>Back</button>
                <button mat-raised-button color="primary" [disabled]="!multiTenancyForm.valid">Submit</button>

            </div>

        </form>


    </mat-step>

<!-- </mat-horizontal-stepper> -->
</mat-vertical-stepper>